import React  from 'react';
import {FieldViewProps} from "../../../../../render/view";

export default function FieldDate_View(props:FieldViewProps) {

    const value = _.get(props.model, props.field.fieldId, null)

    // const classes = Classes("ui5-txt-default", "txt-truncate", props.className, {
    //     'invalid-value': !props.field.isValueValid(value)
    // })

    // <div className="ui5-txt-default">{props.value && Format.dateUserFormat(DatetimeUtils.dateToMoment(props.value))}</div>
    // {!_.isNil(value) && _.get(props.field.components, 'ValuePrefix', false)}

    const classes = Classes("ui5-txt-default", props.className)

    return (
        <div className={classes}>
            {props.field.getDisplayValue(value)}
        </div>
    );
}
